import { useEffect, useState } from 'react'
import logo from '../assets/img/logo.png'
import avatar from '../assets/img/pg-avatar.jpg'
import GetUserSessionStatus from '../helpers/getUserSessionStatus'
import GetUserProfileInfo from '../helpers/getUserProfileInfo'
import { Link } from 'react-router-dom'
import { useAuth } from "../helpers/auth";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const LandingPage = () => {

    const [loginStatus, setLoginStatus] = useState('');
    const [userInfo, setUserInfo] = useState('');
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    const getSessionStatus = async () => {
        const userStatus = await GetUserSessionStatus();
        if (userStatus === 200) {
            setLoginStatus(true);
            getUserProfileInfo();
        } else {
            setLoginStatus(null);
            localStorage.clear();
        }
    }

    const getUserProfileInfo = async () => {
        const response = await GetUserProfileInfo();
        try {
            setUserInfo(response)
        } catch (err) {
            setUserInfo(response)
        }
    }
    useEffect(() => {
        getSessionStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginStatus]);


    return (
        <div className="App">
            <HelmetProvider>
                <Helmet>
                    <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
                    <meta name="author" content="Pablo Giroud" />
                    <meta name="viewport" content="width=device-width - initial-scale=1.0" />
                </Helmet>
                <div className='landing'>
                    <div className='title'>
                        <img data-test='logo' className="img-logo" alt="simple resume logo" src={logo}></img>
                        <h1 data-test='title' className="">simple resume</h1>
                    </div>
                    <div className='btns-bot'>
                        {userInfo
                            ?
                            <div data-test='userInfoModal' className='usr-inf-login'>
                                <img data-test='userImg' src={avatar} alt="" />
                                <div>
                                    <p data-test='userEmail'>{userInfo && userInfo.email}</p>
                                </div>
                            </div> :
                            <></>
                        }
                        {userInfo
                            ? <Link data-test="logout" className="btnSCV btnSCV-a" onClick={handleLogout} >logout</Link>
                            : <div><Link data-test="login" className="btnSCV btnSCV-a" to="/login">login</Link>
                            <Link data-test="register" className="btnSCV btnSCV-c" to="/registration">register</Link></div>
                        }
                    </div>
                </div>
            </HelmetProvider>
        </div>
    );
}

export default LandingPage;